import { ChangeDetectorRef, Component, Inject, ViewChild, TemplateRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { MatDatepicker, MatDatepickerToggle } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UserService } from '@app/core/services/UserService';
import { Observable } from 'rxjs';
import { AuthenticationService } from '@app/core/services/AuthenticationService'
import { CompanyService } from '@app/core/services/CompanyService';
import { UntypedFormControl } from '@angular/forms';
import { IAccountSettings } from '@app/core/interfaces/user/IAccountSettings';
import { IRole } from '@app/core/interfaces/organization/IRole';
import { NgForm } from '@angular/forms';
import { OrganizationService } from '@app/core/services/OrganizationService';
import { BankService } from '@app/core/services/BankService';
import { IBank } from '@app/core/interfaces/economy/IBank';
import { SwedishBankAccountValidationService } from '@app/core/services/SwedishBankAccountValidationService';

@Component({
  standalone: false,
  selector: 'edit-salaryreciever-dialog',
  templateUrl: 'edit-salaryreciever-modal.component.html'
})

export class SalaryRecieverEditComponent {

  public user = {} as IAccountSettings;
  public userExistsInTenant: boolean = false;
  private _dimesionToggle = false;
  private _formValid = false;
  public _imageList: any[] = [];
  public _hasImages = false;
  private _showImageList = false;
  private _showAttachments = false;
  private _hasAttachments = false;
  private _showComments = false;
  private _isCompany = false;
  public _isPrivatePerson = true;
  public personalNumberError: string;
  public organizationId: number = 0;
  public isNewUser: boolean = true;
  @ViewChild('myInput', { static: false })
  myInputVariable: any;
  private _apiBaseUrl: string;
  countries = [];
  orgNumberPattern = "^[0-9]{6}-[0-9]{4}$";
  pNumberPattern = "^[0-9]{6}-[0-9]{4}$";
  emailPattern = "[A-Öa-ö0-9._%+-]+@[A-Öa-ö0-9.-]+\.[A-Öa-ö]{1,63}$";
  isAdmin: boolean = false;
  orgNumberValid: boolean = false;
  pNrValid: boolean = false;
  phoneNumberValid: boolean = true;
  errorMessage: string = "";
  searchCompleted: boolean = false;
  customerSearchTerm: string;
  filteredCustomers: Observable<any[]>;
  selectedCustome: any;
  selectedCustomerObject: any;
  selectedCustomerName: any;
  public searchAccountValue: string;
  customeSearchTerm: string;
  customers: Customer[] = [];
  userCtrl: UntypedFormControl;
  searchAccountResult: any;
  searchByOrgNrCompleted: boolean = false;
  InvoiceSendTypeLocked = false;
  paymentTerms = [0, 10, 15, 20, 25, 30, 45, 60];
  errorMessageOrgnr: string = '';
  errorMessagePnr: string = '';
  errorMessagePhoneNr: string = '';
  roles = [] as IRole[];
  banks: IBank[] = [];
  bankValidationError = '';
  bankEntryMode: 'swedish' | 'personkonto' | 'international' = 'swedish';
  
  @ViewChild('personForm', { static: true }) personForm: NgForm;

  constructor(
    public dialogRef: MatDialogRef<SalaryRecieverEditComponent>,
    private userService: UserService,
    private authenticationService: AuthenticationService,
    private organizationService: OrganizationService,
    private companyService: CompanyService,
    private changeDetectorRef: ChangeDetectorRef,
    private bankService: BankService,
    private swedishBankAccountValidationService: SwedishBankAccountValidationService,
    @Inject(MAT_DIALOG_DATA) public data: any
  )
  {

  }

  ngOnInit() {

    this.getRoles();
    this.getBanks();
    this.isAdmin = this.userService.userHasRole("admin");

    if (this.data.organizationId != null) {
      this.organizationId = this.data.organizationId;
    }

    if (this.data.user != null) {
      this.user = this.data.user;
      this.isNewUser = false;
      this.pNrValid = true;
    }

  }

  getBanks() {
    this.bankService.getAll()
      .subscribe(response => {
        this.banks = response;
        if (this.bankEntryMode === 'international') {
          this.selectInternationalBank();
        }
        this.validateBankInfo(false);
      }, error => this.onError(error));
  }

  onBankEntryModeChange(mode: 'swedish' | 'personkonto' | 'international') {
    this.bankEntryMode = mode;
    this.bankValidationError = '';
    this.user.BankName = '';

    if (mode === 'personkonto') {
      this.user.ClearingNumber = '';
      this.user.AccountNumber = this.getNordeaPersonkontoAccountNumber();
      this.user.Bic = '';
      this.user.Iban = '';
    } else if (mode === 'international') {
      this.user.ClearingNumber = '';
      this.user.AccountNumber = '';
      this.selectInternationalBank();
    } else {
      this.user.AccountNumber = '';
      this.user.Bic = '';
      this.user.Iban = '';
      this.user.Bank = null;
    }

    this.validateBankInfo(false);
  }

  onClearingNumberChange(value: string) {
    this.user.ClearingNumber = value;

    const resolvedBank = this.swedishBankAccountValidationService.resolveBankFromClearing(
      this.banks,
      this.user.ClearingNumber
    );
    this.user.BankName = resolvedBank.resolvedBankName;
    this.user.Bank = resolvedBank.resolvedBank
      ? JSON.parse(JSON.stringify(resolvedBank.resolvedBank))
      : null;

    this.validateBankInfo(false);
  }

  onAccountNumberChange(value: string) {
    this.user.AccountNumber = this.bankEntryMode === 'personkonto'
      ? this.getNordeaPersonkontoAccountNumber()
      : value;
    this.validateBankInfo(false);
  }

  private selectInternationalBank() {
    const bank = this.banks.find(item => item.IsInternational);
    this.user.Bank = bank ? JSON.parse(JSON.stringify(bank)) : null;
    this.user.BankName = bank ? bank.Name : '';
  }

  validateBankInfo(applyMessage: boolean = true): boolean {
    if (this.bankEntryMode === 'international') {
      const bic = (this.user.Bic || '').replace(/[^a-zA-Z0-9]+/g, '').toUpperCase();
      const iban = (this.user.Iban || '').replace(/[^a-zA-Z0-9]+/g, '').toUpperCase();
      const bankIsValid = !!this.user.Bank && this.user.Bank.Id > 0 && this.user.Bank.IsInternational;
      const bicIsValid = /^[A-Z]{6}[A-Z0-9]{2}(?:[A-Z0-9]{3})?$/.test(bic);
      const ibanIsValid = /^[A-Z]{2}[0-9]{2}[A-Z0-9]{11,30}$/.test(iban);

      if (!applyMessage && (!bic || !iban)) {
        this.bankValidationError = '';
        return false;
      }

      if (!bankIsValid || !bicIsValid || !ibanIsValid) {
        this.bankValidationError = !bankIsValid
          ? 'Välj en utländsk bank.'
          : (!bicIsValid ? 'Ange ett giltigt BIC med 8 eller 11 tecken.' : 'Ange ett giltigt IBAN med 15–34 tecken.');
        return false;
      }

      if (applyMessage) {
        this.user.Bic = bic;
        this.user.Iban = iban;
        this.user.ClearingNumber = '';
        this.user.AccountNumber = '';
      }
      this.bankValidationError = '';
      return true;
    }

    if (!this.user.ClearingNumber && !this.user.AccountNumber) {
      this.bankValidationError = '';
      return true;
    }

    const result = this.swedishBankAccountValidationService.validate(
      this.banks,
      this.bankEntryMode === 'personkonto' ? null : this.user.ClearingNumber,
      this.user.AccountNumber,
      this.user.PersonalNumber
    );

    if (!result.isValid) {
      if (applyMessage || !!this.user.AccountNumber) {
        this.bankValidationError = result.message;
      }
      return false;
    }

    this.bankValidationError = '';
    this.user.ClearingNumber = result.normalizedClearingNumber;
    this.user.AccountNumber = result.normalizedAccountNumber;
    this.user.BankName = result.resolvedBankName;
    this.user.Bank = result.resolvedBank ? JSON.parse(JSON.stringify(result.resolvedBank)) : null;
    return true;
  }

  private getNordeaPersonkontoAccountNumber(): string {
    const normalizedPersonalNumber = (this.user?.PersonalNumber || '').replace(/\D+/g, '');
    return normalizedPersonalNumber.length >= 10 ? normalizedPersonalNumber.slice(-10) : '';
  }

  save(user: IAccountSettings) {
    if (!this.validateBankInfo(true)) {
      return;
    }

    if (this.userService.userHasRole('admin')) {

      // admin role only administers other companies
      this.organizationService.addPaymentReciever(this.organizationId, user.PersonalNumber, user.Email, user.AccountNumber, user.ClearingNumber, user.Bank?.Id || 0, user.BankName, user.Bic, user.Iban)
        .subscribe(response => this.onSaved(response), err => this.onErr(err));
    }
    else {
      var currentOrganization = this.authenticationService.getCurrentUserOrganization();
      this.organizationService.addPaymentReciever(currentOrganization.Id, user.PersonalNumber, user.Email, user.AccountNumber, user.ClearingNumber, user.Bank?.Id || 0, user.BankName, user.Bic, user.Iban)
        .subscribe(response => this.onSaved(response), err => this.onErr(err));
    }

  }

  onSaved(response) {
    this.dialogRef.close({
      ...this.user,
      PaymentRecieverId: response
    });
  }

  onErr(response) {
    alert(response.error.ExceptionMessage)
  }

  onUserCreateError(response) {
    if (response.error != null && response.error.ExceptionMessage != null) {
      this.personalNumberError = response.error.ExceptionMessage;
    }
    else {
      alert('Ett fel inträffade!');
    }
  }

  userCreated(response) {
    this.dialogRef.close(response);
  }

  getCountries() {
    this.companyService.getCountries()
      .subscribe(value => this.countries = value,
        error => this.onError(error)
      );
  }

  getRoles() {
    this.organizationService.getRoles(this.organizationId)
      .subscribe(response => this.roles = response,
        error => this.onError(error)
      );
  }

  getCountryName(countryId: number) {
    for (var i = 0; i < this.countries.length; i++) {
      if (this.countries[i].Id == countryId) {

        //this.customer.Country.Name = this.countries[i].Name;

      }
    }
  }

  getErrorMessage() {
    //if (this.customer.OrgNumber != null) {
    //  if (this.customer.OrgNumber != null) {

    //  }
    //}

  }

  cancel() {
    this.dialogRef.close(undefined);
  }

  onError(error: any) {
    alert('An error occured');
    console.log(error);
  }

  onAfterRowSaved(response: IAccountSettings) {
    console.log('Från servern')
    console.log(response);
    this.dialogRef.close(response);
  }

  customerTypeToggle(isCompany: boolean) {
    //this.customer.IsCompany = isCompany;
  }

  customerSelected(event: any) {
    this.getCustomerData(event.option.value);
    this.customerSearchTerm = null;
  }

  getCustomerData(orgNumber: number) {
    this.companyService.getGlobalCompanyByOrgNr(orgNumber.toString())
      .subscribe(response => this.getCustomerDataFinished(response), error => console.log(error));
  }

  getCustomerDataFinished(response: any) {

    if (response.length > 0)
      this.selectedCustomerObject = response[0];
  }

  orgNumberValidCheck(orgNumber: string) {

    //if (orgNumber != null) {

    //  const value: string = orgNumber || '';

    //  // Only check swedish companies automatically
    //  if (this.customer.Country.Name == 'Sverige' || this.customer.Country.Id == 1) {
    //    if (value.match(/^[0-9]{6}-[0-9]{4}$/g)) {
    //      //this.orgNumberValid = true;
    //      this.errorMessageOrgnr = "";

    //      this.GetCompanyByOrgNr(orgNumber);
    //      //this.customer.OrgNumber = orgNumber;
    //    }
    //    else {
    //      this.errorMessageOrgnr = "Organisationsnumret måste vara i formatet NNNNNN-NNNN (10 siffror och vanligt bindestreck)";
    //      this.orgNumberValid = false;
    //    }


    //  }
    //  else {
    //    // Ínternational company
    //    this.orgNumberValid = true;
    //    this.customer.OrgNumber = orgNumber;
    //    this.errorMessageOrgnr = "";
    //  }

    //}
  }

  pNumberValidCheck(pNumber: string) {
    this.userExistsInTenant = false;
    if (pNumber != null) {

      const value: string = pNumber || '';

    //  if (this.customer.Country.Name == 'Sverige' || this.customer.Country.Id == 1) {
        if (value.match(/^^[0-9]{12}$/g)) {
          //this.pNrValid = true;
          this.errorMessagePnr = "";
          this.user.PersonalNumber = pNumber
          if (this.bankEntryMode === 'personkonto') {
            this.user.AccountNumber = this.getNordeaPersonkontoAccountNumber();
            this.validateBankInfo(false);
          }
          this.GetPersonByPersonalNumber(pNumber);

        }
        else {
          this.errorMessagePnr = "Personnumret är inte giltigt. Ange 12 siffror i formatet ÅÅÅÅMMDDNNNN.";
          this.pNrValid = false;
        }

      
    //    //this.customer.OrgNumber = pNumber;
    //  }
    //  else {
    //    // Ej Sverige
    //    this.pNrValid = true;
    //    this.customer.OrgNumber = pNumber;
    //    this.errorMessageOrgnr = "";
    //  }

    }
  }

  phoneNumberValidCheck(phoneNumber: string) {

    //if (phoneNumber != null && phoneNumber != "") {

    //  const value: string = phoneNumber || '';

    //  if (value.match(/^[0-9+-]*$/g)) {
    //    this.phoneNumberValid = true;
    //    this.errorMessagePhoneNr = "";
    //  }
    //  else {
    //    this.errorMessagePhoneNr = "Telefonnummer får bara innehålla siffror, vanligt bindestreck och plustecken";
    //    this.phoneNumberValid = false;
    //  }

    //  this.customer.Phone = phoneNumber;
    //}
    //else {
    //  this.phoneNumberValid = true;
    //  this.customer.Phone = phoneNumber;
    //  this.errorMessageOrgnr = "";
    //}
  }

  GetCompanyByOrgNr(term: string) {

    if (term == null || term == "") {
      return;
    }

    this.companyService.getGlobalCompanyByOrgNr(term)
      .subscribe(
        response => this.onSearchAccountCompleted(response, term),
        error => console.log(error));
  }

  GetPersonByPersonalNumber(term: string) {

    if (term == null || term == "") {
      return;
    }

    term = term.replace("-", "");

    this.userService.getPersonFromSparByPersonalNumber(term)
      .subscribe(
        response => this.onGetPersonFromSparCompleted(response, term),
        error => this.onGetPersonFromSparError(error));
  }

  onGetPersonFromSparError(error) {
    this.pNrValid = false;
    this.errorMessagePnr = 'Personnumret är inte giltigt.';
    this.changeDetectorRef.detectChanges();
  }

  onGetPersonFromSparCompleted(response, term) {

    if (response.hits == 1) {
      //this.user.PersonalNumber 
    //  this.customer.OrgNumber = term

      this.user.FirstName = response.firstName;
      this.user.LastName = response.lastName;
      this.pNrValid = true;
      this.personalNumberError = '';
      this.userExistsInTenant = response.UserExists;
    //  this.customer.NameLocked = true;

    //  this.customer.Address = response.address;
    //  this.customer.AddressLocked = true;

    //  this.customer.Zip = response.zip;
    //  this.customer.ZipLocked = true;

    //  this.customer.City = response.city;
    //  this.customer.CityLocked = true;

    //  this.pNrValid = true;
    }
    else {
      this.pNrValid = false;
      this.errorMessagePnr = 'Personnumret är inte giltigt.';
    }

    this.changeDetectorRef.detectChanges();

  }

  onSearchAccountCompleted(response: IAccountSettings, term) {

    //this.searchAccountResult = response;
    ////this.customer.OrgNumber = term;

    //if (this.searchAccountResult != null) {
    //  this.updateCustomerInfo(this.searchAccountResult);
    //  this.orgNumberValid = true;
    //}
    //else {
    //  this.orgNumberValid = false;
    //}

  }

  formValid() {

    //if (this.isAdmin)
    //  return true;

    //if (this.customer.IsCompany && this.isNewUser && this.orgNumberValid)
    //  return true;

    //if (this.customer.IsCompany && !this.isNewUser && this.customer.Active)
    //  return true;

    //if (!this.customer.IsCompany && this.personForm.valid)
    //  return true;

    //return false;
  }

  IsCompanyOnChange(customer, isCompany) {

    this.pNrValid = false;
    this.orgNumberValid = false;

    customer.IsCompany = isCompany;

    this.searchAccountValue = null;
    customer.NameLocked = false;
    customer.OrgNumber = null;
    customer.Name = null;
    customer.NameLocked = false;
    customer.Address = null
    customer.AddressLocked = false;
    customer.Zip = null
    customer.ZipLocked = false;
    customer.City = null
    customer.CityLocked = false;
    customer.OrgNumber = null;
  }

  updateCustomerInfo(globalCompany: IAccountSettings) {
   
    //this.customer.OrgNumber = globalCompany.OrgNumber;
    //this.customer.Active = globalCompany.Active;
    //this.customer.InvoiceEmail = "";
    //this.customer.PaymentTerm = 0;
    //this.customer.Address = "";
    //this.customer.Address2 = "";
    //this.customer.Zip = "";
    //this.customer.City = "";
    //this.customer.InvoiceSendType = 0;
    //this.customer.PublicInfo = globalCompany.PublicInfo;

    //if (globalCompany.Name != null && globalCompany.Name != "") {
    //  this.customer.Name = globalCompany.Name;
    //  if (globalCompany.Global) {
    //    this.customer.NameLocked = true;
    //  }
    //}

    //if (globalCompany.PaymentTerm != null && globalCompany.PaymentTerm > 0) {
    //  this.customer.PaymentTerm = globalCompany.PaymentTerm;
    //  this.customer.PaymentTermLocked = true;
    //}

    //if (globalCompany.Phone != null && globalCompany.Phone != "") {
    //  this.customer.Phone = globalCompany.Phone;
    //  this.customer.PhoneLocked = true;
    //}

    //if (globalCompany.InvoiceEmail != null && globalCompany.InvoiceEmail != "") {
    //  this.customer.InvoiceEmail = globalCompany.InvoiceEmail;
    //  this.customer.InvoiceEmailLocked = true;
    //}

    //if (globalCompany.Co != null && globalCompany.Co != "") {
    //  this.customer.Co = globalCompany.Co
    //  this.customer.CoLocked = true;
    //}

    //if (globalCompany.Address != null && globalCompany.Address != "") {
    //  this.customer.Address = globalCompany.Address;
    //  if (globalCompany.Global) {
    //    this.customer.AddressLocked = true;
    //  }
    //}

    //if (globalCompany.Address2 != null && globalCompany.Address2 != "") {
    //  this.customer.Address2 = globalCompany.Address2;
    //  this.customer.Address2Locked = true;
    //}

    //if (globalCompany.Zip != null && globalCompany.Zip != "") {
    //  this.customer.Zip = globalCompany.Zip;
    //  if (globalCompany.Global) {
    //    this.customer.ZipLocked = true;
    //  }
    //}

    //if (globalCompany.City != null && globalCompany.City != "") {
    //  this.customer.City = globalCompany.City;
    //  if (globalCompany.Global) {
    //    this.customer.CityLocked = true;
    //  }
    //}

    //if (globalCompany.GlnNumber != null && globalCompany.GlnNumber != "") {
    //  this.customer.GlnNumber = globalCompany.GlnNumber;
    //  this.customer.GlnNumberLocked = true;
    //}

    //if (globalCompany.InvoiceSendType != 0) {
    //  this.customer.InvoiceSendType = globalCompany.InvoiceSendType;
    //  this.customer.InvoiceSendTypeLocked = true;
    //}

    //if (globalCompany.AcceptsInvoiceFee == false) {
    //  this.customer.AcceptsInvoiceFee = false;
    //  this.customer.AcceptsInvoiceFeeLocked = true;
    //}

    //if (globalCompany.InvoiceSendType != 0) {
    //  this.customer.InvoiceSendType = globalCompany.InvoiceSendType;
    //  this.customer.InvoiceSendTypeLocked = true;
    //}
    //else if (globalCompany.InvoiceSendType == null) {
    //  this.customer.InvoiceSendType = 0;
    //}

    //this.customer.TimeReportMandatory = globalCompany.TimeReportMandatory;

    //this.customer.ElectronicReference = globalCompany.ElectronicReference;

  }

}

export class Customer {
  constructor(public name: string) { }
}



